import { lazy } from 'react'

export const messageToAdminLoadables = {
	LoadableMessageToAdmin: lazy(() => import('../containers/MessageToAdmin'))
}
